// extracted by mini-css-extract-plugin
export default {"container":"MainBlock_container__dmRNE","content":"MainBlock_content__gmGUs","title":"MainBlock_title__zmXBO","text":"MainBlock_text__kA8Em"};